export default "__VITE_ASSET__MKm4qz4M__"